import { Button, Column, Drawer, Icon, Typography } from "best-common-react";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import PersonalOnOff from "../requests/personal/PersonalOnOff";
import EventAccessAndCutoff from "./EventAccessAndCutoff";

const DepartmentHolder = styled.div`
  font-size: 14px;
`;

const DepartmentHeader = styled.span`
  display: block;
  font-weight: bold;
  color: black;
`;

const DepartmentValue = styled.span`
  display: block;
  font-weight: 300;
`;

const OverrideSaveDrawer = ({
  personalRequestsOverride,
  setPersonalRequestsOverride,
  accessOverride,
  setAccessOverride,
  cutoffOverride,
  setCutoffOverride,
  department = "",
  departmentDto,
  isOpen = false,
  onSave,
  onClose,
  isEdit = false,
  hasEdited,
  timezone = "America/New_York",
  onDelete,
}) => {
  const [canSave, setCanSave] = useState(false);

  useEffect(() => {
    const accessValid =
      (accessOverride.useDate && accessOverride.date) || (!accessOverride.useDate && accessOverride.hoursBefore > 0);
    const cutoffPersonalValid =
      (cutoffOverride.personalCutoffUseDate && cutoffOverride.personalCutoffDate) ||
      (!cutoffOverride.personalCutoffUseDate && cutoffOverride.personalCutoffHoursBefore > 0);
    const cutoffBusinessValid =
      (cutoffOverride.businessCutoffUseDate && cutoffOverride.businessCutoffDate) ||
      (!cutoffOverride.businessCutoffUseDate && cutoffOverride.businessCutoffHoursBefore > 0);
    const cutoffValid = cutoffPersonalValid && cutoffBusinessValid;
    if (!hasEdited) {
      setCanSave(false);
    } else if (accessOverride.active && cutoffOverride.active) {
      setCanSave(accessValid && cutoffValid);
    } else if (accessOverride.active) {
      setCanSave(accessValid);
    } else if (cutoffOverride.active) {
      setCanSave(cutoffValid);
    } else if (personalRequestsOverride != null) {
      setCanSave(true);
    } else {
      setCanSave(isEdit);
    }
  }, [accessOverride, cutoffOverride, personalRequestsOverride]);

  return (
    <Drawer isOpen={isOpen} size={500} onClose={onClose}>
      <div className="bcr-m-2">
        <Typography variant="titleLarge">Override Ticket Access</Typography>
      </div>
      <div className="bcr-p-1">
        <DepartmentHolder className="bcr-mb-1">
          <DepartmentHeader>Department</DepartmentHeader>
          <DepartmentValue>{department}</DepartmentValue>
        </DepartmentHolder>
        <div className="bcr-mb-3">
          <Column>
            <PersonalOnOff value={personalRequestsOverride} onChange={(value) => setPersonalRequestsOverride(value)} />
          </Column>
        </div>
        <EventAccessAndCutoff
          accessOverride={accessOverride}
          setAccessOverride={setAccessOverride}
          cutoffOverride={cutoffOverride}
          setCutoffOverride={setCutoffOverride}
          timezone={timezone}
        />
      </div>
      <div className="d-flex flex-row" style={{ justifyContent: "space-between" }}>
        <div className="flex-column">
          <Button variant="primary" className="bcr-mx-1" disabled={!canSave} onClick={onSave}>
            Save Override
          </Button>
          <Button variant="default" onClick={onClose}>
            Cancel
          </Button>
        </div>
        {isEdit && (
          <div className="flex-column bcr-mx-0">
            <Button className="bcr-mx-1 flex-end" variant="default" onClick={() => onDelete(departmentDto)}>
              <Icon iconName="fa-trash-alt" />
              Delete Override
            </Button>
          </div>
        )}
      </div>
    </Drawer>
  );
};

export default OverrideSaveDrawer;
